import { HttpClient, HttpParams } from '@angular/common/http';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';

import { Component, Inject, Input, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CaseView } from 'src/app/digigov/models/caseview.model';
import { ToMailComponent } from './to-mail/to-mail.component';

export class Value {
  messages: null;
  msgDisplay: number;
  data: {
    appTypeId: null;
    appliedByPostId: null;
    awaitDateValue: null;
    customXidBean: null;
    dbSchema: null;
    delegationVO: null;
    empId: null;
    extendedVO: null;
    langId: null;
    locId: null;
    lstUpdPost: null;
    reason: string;
    recId: null;
    recIdArr: null;
    recNo: string;
    result: null;
    statusId: null;
  };
  errors: null;
}
export class customData {
  selectedData: CaseView[];
  caseData: { row: { fileId: number; corrNo: string } };
  isFromCustomAction: boolean;
}
@Component({
  selector: 'app-reminder',
  templateUrl: './reminder.component.html',
  styleUrls: ['./reminder.component.scss'],
})
export class ReminderComponent implements OnInit {
  response: string;
  value: Value;
  @Input() caseDetails = null;
  @Input() fullcaseObj: any;
  selectedData = [];

  @Input() case: any;
  @Input() isFromOutboxCases;
  @Input() caseData: any;
  // @Input() CaseView: any;
  fileId: number;
  appTypeId: number;
  paramsone: any;
  caseNo: number;
  dialogRef: MatDialogRef<any>;
  to: any;
  temp: any;
  corrID: any;
  constructor(
    private http: HttpClient,
    private dialog1: MatDialogRef<ReminderComponent>,
    private dialog: MatDialog,

    // @Inject(MAT_DIALOG_DATA) public data: any
    @Inject(MAT_DIALOG_DATA) public data: customData
  ) {}

  ngOnInit(): void {}

  onClick() {
    const caseDataArray = this.data?.selectedData;

    // const caseDataArray = this.data?.selectedData;
    //  caseDataArray.forEach((data) => {
    let app = this.data?.selectedData[0].appTypeId;
    if (this.data?.selectedData[0].appTypeId == '1') {
      // caseDataArray.forEach((data) => {
      const dataForPost = {
        fileId: this.data?.selectedData[0].docId,
        appTypeId: 1,
        // corrId: this.data.corrID,
        // caseNo: data.docNo,
      };
      this.http
        .post('/case-mgmnt/get-email-id-for-reminder', dataForPost)
        .subscribe((res: any) => {
          console.log(' reminder', res);
          let to = res.data;
          let sampleData = {
            data1: caseDataArray,
            emailId: to,
          };

          const dialogRef = this.dialog.open(ToMailComponent, {
            data: sampleData,
          });
          dialogRef.afterClosed().subscribe((res) => {
            console.log('REsponseeeeeeeeeeeeeeeeeeeeeeeee', res);
          });
        });
      this.dialog1.close(true);
    } else if (this.data?.selectedData[0].appTypeId == '3') {
      const dataForPost = {
        corrId: this.data?.selectedData[0].docId,
        appTypeId: 3,
        // corrId: this.data.corrID,
        // caseNo: data.docNo,
      };
      this.http
        .post('/case-mgmnt/get-email-id-for-reminder', dataForPost)
        .subscribe((res: any) => {
          console.log(' reminder', res);
          let to = res.data;
          let sampleData = {
            data1: caseDataArray,
            emailId: to,
          };

          const dialogRef = this.dialog.open(ToMailComponent, {
            data: sampleData,
          });
          dialogRef.afterClosed().subscribe((res) => {
            console.log('REsponseeeeeeeeeeeeeeeeeeeeeeeee', res);
          });
        });
      this.dialog1.close(true);
    } else {
      // caseDataArray.forEach((data) => {
      const dataForPost = {
        fileId: this.data?.selectedData[0].fileId,
        appTypeId: 1,
        corrId: this.data?.selectedData[0].corrID,
        // corrId: this.data.corrID,
        // caseNo: data.docNo,
      };
      this.http
        .post('/case-mgmnt/get-email-id-for-reminder', dataForPost)
        .subscribe((res: any) => {
          console.log(' reminder', res);
          let to = res.data;
          let sampleData = {
            data1: caseDataArray,
            emailId: to,
          };

          const dialogRef = this.dialog.open(ToMailComponent, {
            data: sampleData,
          });
          dialogRef.afterClosed().subscribe((res) => {
            console.log('REsponseeeeeeeeeeeeeeeeeeeeeeeee', res);
          });
          this.dialog1.close(true);
        });
    }
  }
}
